export default __webpack_public_path__ + "static/media/icon04.6a32d244.png";